import { render, staticRenderFns } from "./sysselecter.vue?vue&type=template&id=b0752b3c&scoped=true&"
import script from "./sysselecter.vue?vue&type=script&lang=js&"
export * from "./sysselecter.vue?vue&type=script&lang=js&"
import style0 from "./sysselecter.vue?vue&type=style&index=0&id=b0752b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0752b3c",
  null
  
)

export default component.exports